export const classNames = {
  nextButton:
    'transition-all duration-75 active:translate-y-0.5 active:shadow-sm  m-4 text-2xl rounded bg-mideo-button-dark-green px-4 py-2 font-bold text-white hover:bg-mideo-button-light-green hover:text-mideo-text-black cursor-pointer',
};
